import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Typography,
  notification,
  Switch,
  Modal,
  Tooltip,
} from "antd";

import { Input, Button, Menu, Dropdown } from "antd";
import { SearchOutlined, DownOutlined, ExclamationCircleOutlined } from "@ant-design/icons";


// Images
import React, { useEffect, useState } from "react";
import { cancelBookingById, completeBookingById, getBookingById, getBookings, noshowBookingById, reassignBookingById, recoverBookingById, deleteBookings } from "../api/booking.service";
import { getUserPreferences, updateUserPreferences } from "../api/user.service";
import moment from "moment";
import EditAirportBookingPackageModal from "../components/forms/airport-booking/EditAirportBookingPackageModal";
import AssignDriverToVehicleFormModal from "../components/forms/vehicles/AssignDriverToVehicleFormModal";
import AssignVehicleToBookingModalForm from "../components/forms/airport-booking/AssignVehicleToBookingModalForm";
import TimerCell from "../components/TimerCell";
import config from '../config';

const { Title } = Typography;

function Bookings() {
  
  const [selectedFilter ,setFilter] = useState("all");

  function convertToWhatsapp(phoneNumber, countryCode = "+92") {
    // Remove leading zero from phone number (if it exists)
    if (phoneNumber.startsWith('0')) {
      phoneNumber = phoneNumber.substring(1);
    }
  
    // Combine the country code with the phone number
    const whatsappFormattedNumber = countryCode + phoneNumber;
  
    // Return the WhatsApp URL
    return `${whatsappFormattedNumber}`;
  }

  function formatDate(dateString) {
    return moment(dateString).format('dddd, MMMM Do YYYY');
  }

  function formatTime(timeString) {
    return moment(timeString).format('HH:mm');
  }

  function createWhatsAppMessage(booking) {
    const driver = booking.driver;
    const passengerName = booking.name;
    const pickup = booking.pickup;
    const destination = booking.destination;
    const flightNumber = booking.flightNumber;
    const vehicle = booking.vehicle.registrationNo;
    const additionalPickups = booking.additionalPickups.map(p => p.pickup).join(", ") || 'None';
    const luggageCount = booking.luggageCount;
    const passengers = booking.passengerCount;
    const referenceNo = booking.referenceNo;
    const formattedDateTime = moment(booking.dateTime).format('dddd, MMMM Do YYYY HH:mm');

    const message = `*Hello ${driver.name}*,\n\n`
      + `You have a new booking with the following details:\n\n`
      + `*Reference No*: ${referenceNo}\n`
      + `*Passenger Name*: ${passengerName}\n`
      + `*Pickup Location*: ${pickup}\n`
      + `*Additional Pickups*: ${additionalPickups}\n`
      + `*Destination*: ${destination}\n`
      + `*Flight Number*: ${flightNumber}\n`
      + `*Vehicle*: ${vehicle}\n`
      + `*Number of Passengers*: ${passengers}\n`
      + `*Luggage*: ${luggageCount}\n`
      + `*Date & Time*: ${formattedDateTime}\n\n`
      + `Please ensure to arrive on time and follow any instructions from the passenger.\n\n`
      + `Best Regards,\nSawari Pakistan Team.`;

    return message;
  }


  const handleEmailTask = (record) => {
    const mailtoLink = `mailto:${record.email}`;
    window.location.href = mailtoLink;
  };

  const handleTextDriver = (record) => {
    console.log('record', record);
    // Check if phone number exists in the record
    if (!record?.driver?.mobile) {
      alert("Please assign vehicle first to send message to driver.");
      return;
    }
  
    // Construct the pre-made dynamic message
    const message = createWhatsAppMessage(record)
  
    // URL encode the message
    const encodedMessage = encodeURIComponent(message);
  
    // Construct the WhatsApp URL using the phone number and encoded message
    const whatsappURL = `https://wa.me/${convertToWhatsapp(record?.driver?.mobile)}?text=${encodedMessage}`;
  
    // Open the WhatsApp link
    window.open(whatsappURL, "_blank");
  };


  const handlePrintDownload = (record) => {
    const link = `${config.API_URL}/${record.latestPdf}`;
    window.open(link, '_blank');
  };

  // project table start
  const project = [
    {
      title: "REFERENCE NO",
      dataIndex: "referenceNo",
      width: 100,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Reference No"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.referenceNo
          ? record.referenceNo.toString().toLowerCase().includes(value.toLowerCase())
          : "",
      render: (text, record) => <div><strong>{record.referenceNo}</strong></div>,
    },
    {
      title: "DATE & TIME",
      dataIndex: "dateTime", 
      width: 200,
      sorter: (a, b) => moment(a.dateTime).valueOf() - moment(b.dateTime).valueOf(),
      render: (dateTime) =>
        moment.utc(dateTime).tz("Asia/Karachi").format("DD-MMM-YYYY, HH:mm"),
    },
    {
      title: "PICK UP",
      dataIndex: "pickup",
      width: 100,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Pick Up Address"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.pickup
          ? record.pickup.toString().toLowerCase().includes(value.toLowerCase())
          : "",
      render: (text, record) => (
        <Tooltip title={record.pickup}>
          <div className="cursor-pointer">
            {record.pickup && record.pickup.length > 15 
              ? `${record.pickup.substring(0, 15)}...` 
              : record.pickup}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "TIMER (d h m s)",
      key: "timer",
      width: 100,
      render: (text, record) => (
        <TimerCell dateTime={record.dateTime} referenceNo={record.referenceNo}/>
      ),
    },
    {
      title: "ASSIGNED VEHICLE",
      dataIndex: "vehicle",
      width: "15%",
      key: "vehicle",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Vehicle"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.vehicle && record.vehicle.registrationNo
          ? record.vehicle.registrationNo
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
          : "",
      render: (text, record) => (
        <div className="author-info">
          <div style={{ fontWeight: "bold" }}>
            {`${record?.vehicle?.registrationNo || "N/A"}`}
          </div>
        </div>
      ),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      width: 100,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Status"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.status
          ? record.status.toString().toLowerCase().includes(value.toLowerCase())
          : "",
      render: (text, record) => <div>{record.status.charAt(0).toUpperCase() + record.status.slice(1).toLowerCase()}</div>,
    },
    {
      title: "ACTIONS",
      width: 120,
      render: (text, record) => {
        // Define the common menu items
        const allMenuItems = [
          { key: 'print', label: 'View / Download / Print', onClick: () => handlePrintDownload(record), statuses: ['READY', 'ENROUTE', 'ONBOARD', 'NOSHOW', 'DRAFT_NOSHOW', 'CANCELLED', 'DRAFT_RECOVER', 'COMPLETED'] },
          { key: 'edit', label: 'Edit', onClick: () => getVehicleData(record.referenceNo, false), statuses: ['READY'] },
          { key: 'email', label: 'Email', onClick: () => handleEmailTask(record), statuses: ['READY', 'ENROUTE', 'ONBOARD', 'NOSHOW', 'DRAFT_NOSHOW', 'CANCELLED','DRAFT_RECOVER', 'COMPLETED'] },
          { key: 'text', label: 'Text Driver', onClick: () => handleTextDriver(record), statuses: ['READY', 'ENROUTE', 'ONBOARD'] },
          { key: 'assign', label: 'Assign', onClick: () => getVehicleDataAssign(record.referenceNo), statuses: ['READY'] },
          { key: 'cancel', label: 'Cancel Booking', onClick: () => getVehicleDataCancel(record.referenceNo), statuses: ['READY', 'ENROUTE', 'ONBOARD'] },
          { key: 'recover', label: 'Recover Booking', onClick: () => getVehicleDataRecover(record.id), statuses: ['ENROUTE', 'ONBOARD'] },
          { key: 'noshow', label: 'No Show', onClick: () => getVehicleDataNoshow(record.id), statuses: ['ENROUTE', 'ONBOARD'] },
          { key: 'reassign', label: 'Reassign', onClick: () => getVehicleDataReassign(record.referenceNo), statuses: ['NOSHOW', 'DRAFT_NOSHOW', 'CANCELLED', 'DRAFT_RECOVER'] },
          { key: 'complete', label: 'Complete Booking', onClick: () => getVehicleDataComplete(record.referenceNo), statuses: [ 'ENROUTE', 'ONBOARD'] },
        ];
    
        // Filter the menu items based on the current status of the record
        const filteredMenuItems = allMenuItems.filter(item => item.statuses.includes(record.status));
    
        // Build the menu with filtered items
        const menu = (
          <Menu>
            {filteredMenuItems.map(item => (
              <Menu.Item key={item.key} onClick={item.onClick}>
                {item.label}
              </Menu.Item>
            ))}
          </Menu>
        );
    
        return (
          <Dropdown overlay={menu}>
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              Tasks <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    }
  ];

  const [bookings, setBookings] = useState([]);
  const [orginalBookings, setOriginalBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [vehicleData, setVehicleData] = useState(null);
  const [isViewOnly, setisViewOnly] = useState(false);

  const [isModalOpenAssign, setIsModalOpenAssign] = useState(false);
  const [isModalOpenCancel, setIsModalOpenCancel] = useState(false);
  

  const [isHideElapsedchecked, setChecked] = useState(false);

  // Fetch user preferences on mount
  useEffect(() => {
    const loadPreferences = async () => {
      try {
        const response = await getUserPreferences();
        const preferences = response?.data || {};
        if (preferences.hideElapsedAirportBookings !== undefined) {
          setChecked(preferences.hideElapsedAirportBookings);
        }
      } catch (error) {
        console.error("Error loading preferences:", error);
      }
    };
    loadPreferences();
  }, []);

  // Save preferences when toggle changes
  const handleToggleChange = async (checked) => {
    setChecked(checked);
    try {
      await updateUserPreferences({ hideElapsedAirportBookings: checked });
    } catch (error) {
      console.error("Error saving preferences:", error);
      notification.error({
        message: "Failed to save preference",
      });
      // Revert on error
      setChecked(!checked);
    }
  };

  const fetchBookings = async (filter = 'all') => {
    setLoading(true);
    setError(null);
    try {
      const data = await getBookings(filter);
      const fetchedBookings = data?.data || [];
      setBookings(fetchedBookings);
      setOriginalBookings(fetchedBookings);
      // notification.success({ message: 'Data refreshed' })
    } catch (err) {
      setError('Failed to fetch bookings.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);


  useEffect(() => {
    // Don't apply date/time filtering for live, completed, noshow, or cancelled tabs
    // These tabs should show all bookings regardless of elapsed time
    const filtersToSkipDateFiltering = ['live', 'completed', 'noshow', 'cancelled'];
    
    if (filtersToSkipDateFiltering.includes(selectedFilter)) {
      // For these filters, always show the original bookings without date filtering
      setBookings(orginalBookings);
      return;
    }

    if (isHideElapsedchecked) {
      const filteredBookings = orginalBookings.filter((booking) => {
        const bookingDateTime = moment.utc(booking.dateTime).tz("Asia/Karachi"); // Convert stored UTC to PKT
        const nowInPKT = moment().tz("Asia/Karachi"); // Current time in PKT
        return bookingDateTime.isAfter(nowInPKT);
      });
      setBookings(filteredBookings)
    }
    else {
      setBookings(orginalBookings)
    }

  }, [isHideElapsedchecked, selectedFilter, orginalBookings])

  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_API_URL.replace('https://', 'wss://').replace('http://', 'ws://')); // WebSocket connection to the server

    ws.onopen = () => {
      console.log("Connected to WebSocket server");
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.event === "booking-added" || data.event === "booking-status-change") {
        fetchBookings();
      }
    };

    ws.onclose = () => {
      console.log("Disconnected from WebSocket server");
    };

    // Cleanup WebSocket connection on unmount
    return () => {
      ws.close();
    };
  }, []);

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const getVehicleData = async (id, isViewOnly = false) => {
    setisViewOnly(isViewOnly)
    const data = await getBookingById(id);
    setVehicleData(data.data);
    setIsModalOpenEdit(true);
  }

  const getVehicleDataAssign = async (id) => {
    const data = await getBookingById(id);
    setVehicleData(data.data);
    setIsModalOpenAssign(true);
  }

  const getVehicleDataComplete = async (referenceNo) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to complete booking?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
          handleCompleteConfirm(referenceNo)
      },
      onCancel() {
          console.log("Cancelled");
      },
  });
  }

  const getVehicleDataReassign = async (id) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to reassign booking?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
          handleReassignConfirm(id)
      },
      onCancel() {
          console.log("Cancelled");
      },
  });
  }

  const handleCompleteConfirm = async (refNo) => {
    try {
      const data = await completeBookingById(refNo);
      notification.success({
        message: data.msg
      })
      fetchBookings();
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || 'Something went wrong'
      })
    }
  }

  const handleReassignConfirm = async (id) => {
    try {
      const data = await reassignBookingById(id);
      notification.success({
        message: data.msg
      })
      fetchBookings();
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || 'Something went wrong'
      })
    }
  }

  const handleCancelConfirm = async (refNo) => {
    try {
      const data = await cancelBookingById(refNo);
      notification.success({
        message: data.msg
      })
      fetchBookings();
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || 'Something went wrong'
      })
    }
  }

  const handleRecoverConfirm = async (ID) => {
    try {
      const data = await recoverBookingById(ID);
      notification.success({
        message: data.msg
      })
      fetchBookings();
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || 'Something went wrong'
      })
    }
  }

  const handleNoShowConfirm = async (ID) => {
    try {
      const data = await noshowBookingById(ID);
      notification.success({
        message: data.msg
      })
      fetchBookings();
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || 'Something went wrong'
      })
    }
  }

  const getVehicleDataCancel = async (referenceNo) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to cancel booking?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
          handleCancelConfirm(referenceNo)
      },
      onCancel() {
          console.log("Cancelled");
      },
  });
  }

  const getVehicleDataRecover = async (id) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to recover booking?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        handleRecoverConfirm(id)
      },
      onCancel() {
        console.log("Recovered");
      },
    });
  }

  const getVehicleDataNoshow = async (id) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to mark booking as no show?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        handleNoShowConfirm(id)
      },
      onCancel() {
        console.log("Noshow marked");
      },
    });
  }

  const handleBulkDelete = async () => {
    if (selectedRowKeys.length === 0) {
      notification.warning({
        message: 'Please select at least one booking to delete'
      });
      return;
    }

    Modal.confirm({
      title: (
        <span style={{ color: '#ff4d4f', fontWeight: 'bold', fontSize: '18px' }}>
          <ExclamationCircleOutlined style={{ marginRight: 8 }} />
          Warning - Permanent Deletion
        </span>
      ),
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div style={{ fontSize: '16px', marginTop: 10 }}>
          <p style={{ fontWeight: 'bold', marginBottom: 10 }}>
            Are you sure you want to permanently delete <strong style={{ color: '#ff4d4f' }}>{selectedRowKeys.length}</strong> booking(s)?
          </p>
          <p style={{ color: '#ff4d4f', marginTop: 10 }}>
            ⚠️ This action cannot be undone. All selected bookings will be permanently removed from the database.
          </p>
        </div>
      ),
      okText: "Yes, Delete Permanently",
      okType: "danger",
      cancelText: "Cancel",
      width: 500,
      onOk: async () => {
        try {
          setLoading(true);
          // Convert referenceNos to IDs
          const ids = selectedRowKeys.map(refNo => {
            const booking = bookings.find(b => b.referenceNo === refNo);
            return booking?.id;
          }).filter(id => id !== undefined);
          
          const response = await deleteBookings(ids);
          notification.success({
            message: response.msg || `Successfully deleted ${response.data?.deletedCount || ids.length} booking(s)`
          });
          setSelectedRowKeys([]);
          fetchBookings(selectedFilter);
        } catch (error) {
          notification.error({
            message: error?.response?.data?.msg || error?.response?.data?.message || 'Failed to delete bookings'
          });
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Bulk delete cancelled");
      },
    });
  }

  useEffect(() => {
    fetchBookings();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelAssign = () => {
    setIsModalOpenAssign(false);
  };

  const handleOkAssign = () => {

  }

  const onChangeFilter = (e) =>{
    setFilter(e.target.value)
    fetchBookings(e.target.value)

    setTimeout(() => {
      if (e.target.value !== 'upcoming') {
        setChecked(false);
      } else {
        setChecked(true);
      }
    }, 500);
  }

  return (
    <>
      <div className="ant-filtertabs mb-4">
        <div className="flex justify-end antd-pro-pages-dashboard-analysis-style-salesExtra items-center">
          <Switch
            checked={isHideElapsedchecked}
            onChange={handleToggleChange}
          />
          <span style={{ marginLeft: 8, marginRight: 16 }}>
            {"Hide elapsed bookings"}
          </span>
          <Radio.Group onChange={onChangeFilter} defaultValue="all">
            <Radio.Button value="all">ALL</Radio.Button>
            <Radio.Button value="upcoming">UPCOMING</Radio.Button>
            <Radio.Button value="live">LIVE</Radio.Button>
            <Radio.Button value="completed">COMPLETED</Radio.Button>
            <Radio.Button value="noshow">NO SHOW</Radio.Button>
            <Radio.Button value="cancelled">CANCELLED</Radio.Button>
          </Radio.Group>
        </div>
      </div>
      {vehicleData &&
        <AssignVehicleToBookingModalForm vehicleData={vehicleData} fetchAllVehicles={fetchBookings} handleCancel={handleCancelAssign} handleOk={handleOkAssign} isModalOpen={isModalOpenAssign} setIsModalOpen={setIsModalOpenAssign} />}
      {vehicleData && <EditAirportBookingPackageModal isViewOnly={isViewOnly} vehicleData={vehicleData} fetchVehicles={fetchBookings} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Airport Bookings Table"
              extra={
                selectedRowKeys.length > 0 && (
                  <Button
                    type="primary"
                    danger
                    onClick={handleBulkDelete}
                    loading={loading}
                  >
                    Delete Selected ({selectedRowKeys.length})
                  </Button>
                )
              }
            >
              <div className="table-responsive">
                <Table
                  rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                  }}
                  rowKey="referenceNo"
                  columns={project.filter(col => {
                    // Hide timer column for live, completed, noshow, and cancelled tabs
                    if (col.key === 'timer') {
                      return !['live', 'completed', 'noshow', 'cancelled'].includes(selectedFilter);
                    }
                    return true;
                  })}
                  dataSource={bookings}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Bookings;
